jQuery(document).ready(function ($) {
  $(".cat_listing").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Previous" width="33" height="33"></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Next" width="19" height="33"></button>',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // W3C's JS Code
  var acc = document.getElementsByClassName("accordion");
  var i;

  // Open the first accordion
  var firstAccordion = acc[0];
  if (firstAccordion && firstAccordion.nextElementSibling) {
    var firstPanel = firstAccordion.nextElementSibling;
    firstAccordion.classList.add("active");
    firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
  }

  // Add onclick listener to every accordion element
  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function () {
      // For toggling purposes detect if the clicked section is already "active"
      var isActive = this.classList.contains("active");

      // Close all accordions
      var allAccordions = document.getElementsByClassName("accordion");
      for (j = 0; j < allAccordions.length; j++) {
        // Remove active class from section header
        allAccordions[j].classList.remove("active");

        // Remove the max-height class from the panel to close it
        var panel = allAccordions[j].nextElementSibling;
        var maxHeightValue = getStyle(panel, "maxHeight");

        if (maxHeightValue !== "0px") {
          panel.style.maxHeight = null;
        }
      }

      // Toggle the clicked section using a ternary operator
      isActive ? this.classList.remove("active") : this.classList.add("active");

      // Toggle the panel element
      var panel = this.nextElementSibling;
      var maxHeightValue = getStyle(panel, "maxHeight");

      if (maxHeightValue !== "0px") {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    };
  }

  // Cross-browser way to get the computed height of a certain element. Credit to @CMS on StackOverflow (http://stackoverflow.com/a/2531934/7926565)
  function getStyle(el, styleProp) {
    var value,
      defaultView = (el.ownerDocument || document).defaultView;
    // W3C standard way:
    if (defaultView && defaultView.getComputedStyle) {
      // sanitize property name to css notation
      // (hypen separated words eg. font-Size)
      styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
      return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    } else if (el.currentStyle) {
      // IE
      // sanitize property name to camelCase
      styleProp = styleProp.replace(/\-(\w)/g, function (str, letter) {
        return letter.toUpperCase();
      });
      value = el.currentStyle[styleProp];
      // convert other units to pixels on IE
      if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
        return (function (value) {
          var oldLeft = el.style.left,
            oldRsLeft = el.runtimeStyle.left;
          el.runtimeStyle.left = el.currentStyle.left;
          el.style.left = value || 0;
          value = el.style.pixelLeft + "px";
          el.style.left = oldLeft;
          el.runtimeStyle.left = oldRsLeft;
          return value;
        })(value);
      }
      return value;
    }
  }
  // Add onclick listener to every accordion element
  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function () {
      // Check if the clicked section is already "active"
      var isActive = this.classList.contains("active");

      // If it's already active, do nothing
      if (isActive) {
        return;
      }

      // Close all accordions
      var allAccordions = document.getElementsByClassName("accordion");
      for (j = 0; j < allAccordions.length; j++) {
        // Remove active class from section header
        allAccordions[j].classList.remove("active");

        // Remove the max-height class from the panel to close it
        var panel = allAccordions[j].nextElementSibling;
        var maxHeightValue = getStyle(panel, "maxHeight");

        if (maxHeightValue !== "0px") {
          panel.style.maxHeight = null;
        }
      }

      // Toggle the clicked section using a ternary operator
      isActive ? this.classList.remove("active") : this.classList.add("active");

      // Toggle the panel element
      var panel = this.nextElementSibling;
      var maxHeightValue = getStyle(panel, "maxHeight");

      if (maxHeightValue !== "0px") {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    };
  }

  // Custom Featured Collection Slider
  $(".custom_featured_collection").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Previous" width="33" height="33"></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Next" width="19" height="33"></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).ready(function () {
    var $slider = $(".custom-banner-slider");

    $slider.on("init", function (event, slick) {
      if (slick.slideCount <= 1) {
        $slider.find(".slick-dots").hide();
      }
    });

    $slider.slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow:
        '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_3.svg?v=1701092280" alt="Previous" width="27" height="53"></button>',
      nextArrow:
        '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_3.svg?v=1701092280" alt="Next" width="27" height="23"></button>',
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      pauseOnFocus: false,
      fade: true,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  });

  var $div = $(".main-banner ").eq(1);
  $div.css("display", "block");
});

// Custom Featured Collection Slider
function initializeSlickSlider() {
  $(".related-product-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Previous" width="33" height="33"></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Next" width="19" height="33"></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
var checkContentIntervalrelated = setInterval(function () {
  var relatedproductslider = $(".related-product-slider");
  if (
    relatedproductslider.length > 0 &&
    relatedproductslider.children().length > 0
  ) {
    initializeSlickSlider();
    clearInterval(checkContentIntervalrelated);
  }
}, 100);
function initializeSlickSlidercstm() {
  $(".recently-viewed-grid").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Previous" width="33" height="33"></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0367/4354/4967/files/right-arrow_1.svg?v=1700737893" alt="Next" width="19" height="33"></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
var checkContentInterval = setInterval(function () {
  if ($(".recently-viewed-grid").children().length > 0) {
    initializeSlickSlidercstm(); // Initialize the Slick Slider
    clearInterval(checkContentInterval); // Clear the interval
  }
}, 100); // Adjust the interval duration as needed

$(".moreless-button").click(function (event) {
  event.preventDefault();
  // Find the corresponding moretext element for the clicked button
  var moretext = $(this).siblings(".moretext");

  moretext.slideToggle();
  $(this).toggleClass("read-less");

  // Set the text based on the presence of the 'read-less' class
  $(this).text($(this).hasClass("read-less") ? "Read less" : "Read more");
});


// Video Play Pause 
jQuery(document).ready(function($) {
  var vidIcon = $('#vid-icon');
  var video = $('#videoElement'); // Get the video using jQuery

  if (vidIcon.length && video.length) {
    vidIcon.on('click', function() {
      console.log("Clicked");

      // Toggle play/pause on video
      if (video[0].paused) {
        video[0].play();
        $('.video-col').addClass('playing').removeClass('pause'); // Add playing, remove pause
      } else {
        video[0].pause();
        $('.video-col').addClass('pause').removeClass('playing'); // Add pause, remove playing
      }
    });
  } else {
    console.log('Video or video icon not found!');
  }
});